export const initialise = () => {
    const dialogs: NodeListOf<HTMLDialogElement> = document.querySelectorAll('dialog[data-dialog-video]');

    dialogs.forEach((dialog: HTMLDialogElement) => {
        const parent: HTMLElement | null = dialog.parentElement;
        if (!parent) return;

        const dialogOpenButton: HTMLButtonElement | null = parent.querySelector('button[data-dialog-open-button]');
        const dialogCloseButton: HTMLButtonElement | null = parent.querySelector('button[data-dialog-close-button]');
        if (!dialogOpenButton || !dialogCloseButton) return;

        const iframe: HTMLIFrameElement | null = dialog.querySelector('iframe');
        if (!iframe) return;

        let sourceUrlString = iframe.src;
        
        // Handle YouTube watch URLs
        if (sourceUrlString.includes("watch?v=")) {
            sourceUrlString = sourceUrlString.replace("watch?v=", "embed/");
        } 
        // Handle youtu.be short URLs
        else if (sourceUrlString.includes("youtu.be/")) {
            sourceUrlString = sourceUrlString.replace("youtu.be/", "youtube.com/embed/");
        }
        
        // Convert YouTube URLs to youtube-nocookie
        if (sourceUrlString.includes('youtube.com')) {
            sourceUrlString = sourceUrlString.replace('youtube.com', 'youtube-nocookie.com');
            
            // Ensure iframe has proper YouTube attributes
            if (!iframe.hasAttribute('allow')) {
                iframe.setAttribute('allow', 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share');
            }
            if (!iframe.hasAttribute('referrerpolicy')) {
                iframe.setAttribute('referrerpolicy', 'strict-origin-when-cross-origin');
            }
            if (!iframe.hasAttribute('allowfullscreen')) {
                iframe.setAttribute('allowfullscreen', '');
            }
        }
        
        let sourceUrl = new URL(sourceUrlString);
        
        const urlParameters = [
            { name: 'enablejsapi', value: '1' },
            { name: 'autoplay', value: '1' },
            { name: 'origin', value: window.location.origin }
        ];

        urlParameters.forEach((parameter) =>
            sourceUrl.searchParams.append(parameter.name, parameter.value.toString())
        );
        const formattedUrl: string = sourceUrl.href;

        document.body.appendChild(dialog);

        dialogOpenButton?.addEventListener('click', () => {
            document.body.classList.add('dialog-open');
            dialog.showModal();
            iframe.src = formattedUrl;
        });

        dialogCloseButton?.addEventListener('click', () => {
            dialog.close();
        });

        dialog.addEventListener('click', (event) => {
            if (event.target === dialog) {
                dialog.close();
            }
        });

        dialog.addEventListener('keydown', (event) => {
            if (event.key === 'Escape') {
                dialog.close();
            }
        });



        dialog.addEventListener('close', () => {
            document.body.classList.remove('dialog-open');
            iframe.contentWindow?.postMessage('{"event": "command","func": "stopVideo","args": ""}', "*");
        });
    });
};